import { EmployeesDataSource, EmployeeDataType } from './../sources/employees-data-source';
import { SkillsDataSource } from './../sources/skills-data-source';
import { EmployeesToAllocationsDataSource } from './../sources/employees-to-allocations-data-source';
import { TribesDataSource } from '../sources/tribes-data-source';
import { AccountsDataSource } from '../sources/accounts-data-source';
import store from '@/store/store';
import { AccountClustersDataSource } from '../sources/account-clusters-data-source';
import {HivesDataSource} from "../sources/hives-data-source";
import {CapabilityDataSource} from "@/data-management/data-sources/sources/capabilities-data-source";

export class DataSourceLoader {
    public employeesDataSource: EmployeesDataSource;
    public skillsDataSource: SkillsDataSource;
    public tribeDataSource: TribesDataSource;
    public hiveDataSource: HivesDataSource;
    public accountDataSource: AccountsDataSource;
    public capabilitiesDataSource: CapabilityDataSource;
    public authenticatedEmployee: EmployeeDataType;
    public accountClusterDataSource: AccountClustersDataSource;

    public employeesToAllocationsDataSource: EmployeesToAllocationsDataSource;

    constructor() {
        this.init();
    }

    public init() {
        this.employeesDataSource = new EmployeesDataSource(store.state.data.flatEmployees);
        this.skillsDataSource = new SkillsDataSource(store.state.data.skills);
        this.tribeDataSource = new TribesDataSource(store.state.data.tribes);
        this.hiveDataSource = new HivesDataSource(store.state.data.hives);
        this.accountDataSource = new AccountsDataSource(store.state.data.accounts);
        this.capabilitiesDataSource = new CapabilityDataSource(store.state.data.capabilities);
        this.accountClusterDataSource = new AccountClustersDataSource(store.state.data.accountClusters);
        this.authenticatedEmployee = this.employeesDataSource.data
            .filter(
                employee =>
                    employee.Email && employee.Email.toLowerCase() === store.state.user.user.emailAddress.toLowerCase()
            )
            .shift();

        this.employeesToAllocationsDataSource = new EmployeesToAllocationsDataSource(
            store.state.data.flatEmployees.Allocations,
            this.employeesDataSource
        );
    }
}
